"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreUsersIdMapSlice = void 0;
const xuder_1 = require("@sonar-software/xuder");
const state_1 = require("./state.js");
exports.coreUsersIdMapSlice = (0, xuder_1.createUpdateSyncSlice)({
    name: 'CoreUsersIdMap',
    state: state_1.defaultUserIdMapState,
    transform: (action, state = {}) => {
        var _a;
        if (!action.length) {
            return state;
        }
        const updatedState = Object.assign({}, state);
        for (const entry of action) {
            const existingEntry = (_a = state[entry.userId]) !== null && _a !== void 0 ? _a : {};
            if (existingEntry.profilePicture &&
                entry.profilePicture &&
                existingEntry.profilePicture !== entry.profilePicture) {
                URL.revokeObjectURL(existingEntry.profilePicture);
            }
            const updatedEntry = Object.assign(Object.assign({}, existingEntry), entry);
            updatedEntry.fullName = `${updatedEntry.firstName} ${updatedEntry.lastName}`;
            updatedState[entry.userId] = updatedEntry;
        }
        return updatedState;
    }
});
//# sourceMappingURL=update.js.map